import { c as _c } from "react/compiler-runtime";
export default function QuoteIcon(params) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M14.5 23V12C14.4983 10.4092 13.8657 8.88405 12.7408 7.75919C11.616 6.63433 10.0908 6.00165 8.5 6C8.23478 6 7.98043 6.10536 7.79289 6.29289C7.60536 6.48043 7.5 6.73478 7.5 7C7.5 7.26522 7.60536 7.51957 7.79289 7.70711C7.98043 7.89464 8.23478 8 8.5 8C9.56087 8 10.5783 8.42143 11.3284 9.17157C12.0786 9.92172 12.5 10.9391 12.5 12V13H5C4.46957 13 3.96086 13.2107 3.58579 13.5858C3.21071 13.9609 3 14.4696 3 15V23C3 23.5304 3.21071 24.0391 3.58579 24.4142C3.96086 24.7893 4.46957 25 5 25H12.5C13.0304 25 13.5391 24.7893 13.9142 24.4142C14.2893 24.0391 14.5 23.5304 14.5 23ZM27 25H19.5C18.9696 25 18.4609 24.7893 18.0858 24.4142C17.7107 24.0391 17.5 23.5304 17.5 23V15C17.5 14.4696 17.7107 13.9609 18.0858 13.5858C18.4609 13.2107 18.9696 13 19.5 13H27V12C27 10.9391 26.5786 9.92172 25.8284 9.17157C25.0783 8.42143 24.0609 8 23 8C22.7348 8 22.4804 7.89464 22.2929 7.70711C22.1054 7.51957 22 7.26522 22 7C22 6.73478 22.1054 6.48043 22.2929 6.29289C22.4804 6.10536 22.7348 6 23 6C24.5908 6.00165 26.116 6.63433 27.2408 7.75919C28.3657 8.88405 28.9983 10.4092 29 12V23C29 23.5304 28.7893 24.0391 28.4142 24.4142C28.0391 24.7893 27.5304 25 27 25Z" fill="currentColor" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== params) {
    t1 = <svg {...params} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">{t0}</svg>;
    $[1] = params;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}